import React, { forwardRef } from 'react';

import { classNames }  from '../lib/classNames';

export interface ICardProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: `default` | `soft`;
}

export function Card({ children, className, id, variant = `default` }: ICardProps) {
  return (
    <div
      id={ id }
      className={
        classNames(
          variant === `default` && `rounded-lg bg-white shadow-sm px-4 py-5 sm:p-5`,
          variant === `soft` && `rounded-xl bg-white/70 ring-1 ring-black/5 px-4 py-5 sm:p-5`,
          className,
        )
      }
    >
      { children }
    </div>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ForwardRefCard = forwardRef<any, any>(({ children, className, id, variant = `default` }, ref) => {
  return (
    <div
      id={ id }
      className={
        classNames(
          variant === `default` && `rounded-lg bg-white shadow-sm px-4 py-5 sm:p-5`,
          variant === `soft` && `rounded-xl bg-white/70 ring-1 ring-black/5 px-4 py-5 sm:p-5`,
          className,
        )
      }
      ref={ ref }
    >
      { children }
    </div>
  );
} );

ForwardRefCard.displayName = `Card`;

